/* Ability Warehouse — sticky filter bar for the Find your product page.
   Docks under the header once the "Browse & narrow" board scrolls away, so you can keep filtering while the results stay in view.
   Options are cloned from the live board, so the finder's own click handling applies to them. */
(function () {
  'use strict';
  var sec = document.querySelector('[data-product-match][data-layout="full"]');
  var bar = sec && sec.querySelector('[data-tm-bar]');
  var steps = sec && sec.querySelector('[data-tm-steps]');
  var board = sec && sec.querySelector('.tm__board');
  var results = sec && sec.querySelector('[data-tm-results]');
  if (!sec || !bar || !steps || !board || !results) return;

  var chips = bar.querySelector('[data-tmb-chips]');
  var pop = bar.querySelector('[data-tmb-pop]');
  var countEl = bar.querySelector('[data-tmb-count]');
  var openKey = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function label(li) {
    var on = [].slice.call(li.querySelectorAll('.tm__opt.is-on .tm__opt-l')).map(function (l) { return l.firstChild.textContent.trim(); });
    if (li.dataset.step === 'budget') {
      var lo = li.querySelector('[data-lo-v]'), hi = li.querySelector('[data-hi-v]');
      return li.classList.contains('is-done') && lo && hi ? [lo.textContent + ' – ' + hi.textContent] : [];
    }
    return on;
  }

  function build() {
    var html = '';
    [].forEach.call(steps.querySelectorAll('.tm__step[data-step]'), function (li) {
      var key = li.dataset.step, q = li.querySelector('.tm__q'), sel = label(li);
      var name = { where: 'Where', what: 'What\'s hard', budget: 'Budget', who: 'Who' }[key] || (q ? q.textContent : key);
      var val = sel.length ? (sel.length > 2 ? sel[0] + ' +' + (sel.length - 1) : sel.join(', ')) : '';
      html += '<button type="button" class="tmb__chip' + (sel.length ? ' is-set' : '') + (openKey === key ? ' is-open' : '') + '" data-tmb-chip="' + key + '" aria-expanded="' + (openKey === key) + '">' +
        '<span class="tmb__k">' + name + '</span>' + (val ? '<span class="tmb__v">' + val + '</span>' : '') + '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M3 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    });
    chips.innerHTML = html;
    var hl = results.querySelector('[data-tm-res-title] .tm__hl');
    countEl.textContent = hl ? hl.textContent : '';
    var any = steps.querySelector('.tm__step.is-done');
    bar.querySelector('[data-tmb-clear]').hidden = !any;
    fillPop();
  }

  function fillPop() {
    if (!openKey) { pop.hidden = true; pop.innerHTML = ''; return; }
    var li = steps.querySelector('.tm__step[data-step="' + openKey + '"]');
    if (!li) { openKey = null; pop.hidden = true; return; }
    var src = openKey === 'budget' ? li.querySelector('.tm__quick') : li.querySelector('.tm__opts');
    var q = li.querySelector('.tm__q'), clear = li.querySelector('[data-clear]');
    pop.innerHTML = '<div class="page-width tmb__pop-in"><div class="tmb__pop-head"><b>' + (q ? q.textContent : '') + '</b>' + (clear ? '<button type="button" class="tm__clear" data-clear="' + openKey + '">Clear</button>' : '') + '<button type="button" class="tmb__close" data-tmb-close aria-label="Close">×</button></div>' + (src ? src.outerHTML : '') + '</div>';
    pop.hidden = false;
  }

  bar.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-tmb-chip]');
    if (chip) { openKey = openKey === chip.dataset.tmbChip ? null : chip.dataset.tmbChip; build(); return; }
    if (e.target.closest('[data-tmb-close]')) { openKey = null; build(); return; }
    if (e.target.closest('[data-tmb-top]')) { e.preventDefault(); board.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  });
  document.addEventListener('click', function (e) { var path = e.composedPath ? e.composedPath() : []; if (openKey && path.indexOf(bar) < 0 && !bar.contains(e.target)) { openKey = null; build(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openKey) { openKey = null; build(); } });

  /* The finder re-renders the board after every choice; mirror it. */
  new MutationObserver(function () { build(); }).observe(steps, { childList: true });
  new MutationObserver(function () { var hl = results.querySelector('[data-tm-res-title] .tm__hl'); countEl.textContent = hl ? hl.textContent : ''; }).observe(results.querySelector('[data-tm-res-title]'), { childList: true, subtree: true });
  build();

  /* Show once the board has scrolled above the header; hide again when it comes back. */
  function headerH() { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0; }
  var shown = false;
  function update() {
    var r = board.getBoundingClientRect();
    var past = r.bottom < headerH() + 8;
    var inResults = results.getBoundingClientRect().bottom > headerH() + 120;
    var want = past && inResults;
    if (want !== shown) {
      shown = want;
      bar.classList.toggle('is-shown', shown);
      document.documentElement.classList.toggle('tmb-on', shown);
      if (!shown) { openKey = null; build(); }
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();